import { gql } from "@apollo/client";

export const DOCUMENT_MESSAGES_QUERY = gql`
  query documentMessages($documentId: Int!) {
    documentMessages(documentId: $documentId) {
      documentId
      documentMessages {
        messageType
        messageCode
        data
      }
    }
  }
`;
